<script setup lang="ts">
const { row } = defineProps<{ row: Record<string, unknown> }>();
</script>

<template>
  <span class="cell-action">
    <slot name="action" :row="row" />
  </span>
</template>

<style scoped lang="scss">
.cell-action {
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
}
</style>
